import React from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import Link from 'next/link';
import SideBar from './SideBar';
import { HeaderH2, HeaderH1, Text, NextButton } from 'components/TextBlocks';
import Image from 'next/image';

function TrialSaves(props) {
    return (
        <>
            <HeaderH1>Trial plan</HeaderH1>
            <Text>
                The trial plan includes 30 saves to the database where your data
                is kept.
            </Text>
            <Text>Actions that count towards your trial limit is:</Text>
            <Text>
                <span style={{ fontWeight: '500' }}>
                    • Dropping and saving a tab into a group
                </span>
            </Text>
            <Text>
                <span style={{ fontWeight: '500' }}>
                    • Creating a Note or To-do item
                </span>
            </Text>
            <Text>
                <span style={{ fontWeight: '500' }}>
                    • Doing a save all(To a new group or existing)
                </span>
            </Text>
            <Text>Creating categories or groups is not counted as saves.</Text>
            <Text>
                To upgrade your account and get unlimited saves see{' '}
                <Link href="/pricing">pricing</Link>.
            </Text>
            <NextButton
                cta={'Create new group'}
                textColor={'#565D65'}
                bg={'#EBECED'}
                page={'/guide/create-new-group'}
            />
        </>
    );
}

TrialSaves.Layout = SideBar;

export default TrialSaves;
